<template>
  <ValidationObserver ref="publishingScheduleForm">
    <ValidationProvider v-slot="{ errors }" name="name" rules="required">
      <v-text-field
        :error-messages="getErrorMessages(errors)"
        label="Name"
        class="mb-4 mt-2"
        v-model="publishingScheduleData.name"
        :readonly="isUpdate"
      />
    </ValidationProvider>
    <h3>Tiers</h3>
    <Tier
      v-for="tier in tiers"
      :key="tier.tier_nbr"
      :tier="tier"
      :showValidationErrors="showValidationErrors"
      @remove="removeTier"
    />
    <PrimaryButton class="my-2" full-width light @click.native="addTier">
      Add Tier
      <v-icon>mdi-plus</v-icon>
    </PrimaryButton>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { each, filter, merge } from "lodash";
import { mapState } from "vuex";
import { createNamespacedHelpers } from "vuex";
import Tier from "@/views/settings/components/publishing-schedule-templates/components/Tier";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { size, map } from "lodash";
import { ORGANISATION_SCHEDULES_NAMESPACE } from "@/store/modules/organisations/organisation-schedules";
import { DELETE_TIER } from "@/store/modules/organisations/organisation-schedules/actions";

const { mapActions } = createNamespacedHelpers(
  ORGANISATION_SCHEDULES_NAMESPACE
);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Tier,
    PrimaryButton
  },
  props: {
    publishingScheduleTemplate: {
      type: Object,
      default: () => ({})
    },
    isUpdate: Boolean
  },
  data() {
    return {
      publishingScheduleData: {
        name: ""
      },
      tiers: [],
      showValidationErrors: false,
      tiersToBeDeleted: []
    };
  },
  created() {
    if (this.publishingScheduleTemplate) {
      this.adjustpublishingScheduleData();
    }
  },
  computed: {
    ...mapState("auth", {
      user: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      deleteTier: DELETE_TIER
    }),
    adjustpublishingScheduleData() {
      this.publishingScheduleData = merge({}, this.publishingScheduleTemplate);
      this.tiers = map(this.publishingScheduleTemplate.tiers, tier => ({
        ...tier
      }));
    },
    close() {
      this.$emit("close");
    },
    async validateForm() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.publishingScheduleForm.validate();
      if (isValid) {
        this.deleteTiers();
        this.$emit("onSubmit", {
          publishingScheduleTemplate: this.publishingScheduleData,
          tiers: this.tiers
        });
      }
      return isValid;
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    addTier() {
      const tier_nbr = size(this.tiers) + 1;
      this.tiers = [
        ...this.tiers,
        {
          tier_nbr,
          tier_name: "",
          publishing_delay_hours: 0,
          publishingChannels: []
        }
      ];
    },
    removeTier(tierToBeRemove) {
      this.tiers = filter(this.tiers, tier => tier !== tierToBeRemove);
      if (tierToBeRemove.id) {
        this.tiersToBeDeleted = [...this.tiersToBeDeleted, tierToBeRemove];
      }
      this.updateNbr();
    },
    updateNbr() {
      this.tiers = each(this.tiers, (tier, index) => {
        tier.tier_nbr = index + 1;
        return tier;
      });
    },
    deleteTiers() {
      map(this.tiersToBeDeleted, ({ id }) => this.deleteTier(id));
    }
  }
};
</script>

<style lang="scss"></style>
